import type { I18N } from '.';

export const nl = {
  loginWith: 'Inloggen met',
  approveWith: 'Goedkeuren met',
  signWith: 'Ondertekenen met',
  confirmWith: 'Bevestigen met',
  acceptWith: 'Accepteren met',
  sameDevice: 'Op dit apparaat',
  anotherDevice: 'Met uw SSN',
  anotherDeviceQR: 'Op een ander apparaat',
  mitidBusiness: 'MitID Business',
  finnishMobileID: 'Finse mobiel certificaat',
  finnishBankID: 'Finse BankID',
  swedishBankID: 'Zweedse BankID',
  norwegianBankID: 'Noorse BankID',
  biometrics: 'Biometrie',
  openAndScan: 'Open de BankID-app op uw mobiele apparaat en scan de QR-code.',
  thisIsTheQR:
    'Dit is een BankID QR-code. U kunt erop klikken om het in een volledig scherm te bekijken',
  completingLogin: 'Uw login voltooien.',
} satisfies I18N;
